import moment from 'moment';
import * as Yup from 'yup';

import { FORM_VALIDATION_ERRORS, FORM_VALIDATION_PHONE_REGEX } from 'src/consts';

const capsuleValidation = {
  //http://regexlib.com/Search.aspx?k=phone&AspxAutoDetectCookieSupport=1
  phone: (errorString = FORM_VALIDATION_ERRORS.mobilePhone) =>
    Yup.string().trim().matches(FORM_VALIDATION_PHONE_REGEX, errorString),
  doctorPhone: (errorString = FORM_VALIDATION_ERRORS.doctorNumber) =>
    Yup.string().trim().matches(FORM_VALIDATION_PHONE_REGEX, errorString),
  date: (errorString = FORM_VALIDATION_ERRORS.birthdate) =>
    Yup.string()
      .test({
        message: errorString,
        test: value => moment(value, 'MM/DD/YYYY', true).isValid(), // strict mode date parsing
      })
      .test({
        message: FORM_VALIDATION_ERRORS.birthdate_max,
        test: value => new Date(value) < new Date(),
      })
      .test({
        message: FORM_VALIDATION_ERRORS.birthdate_min,
        test: value => new Date(value).getFullYear() >= 1900,
      }),
  zip: (errorString = FORM_VALIDATION_ERRORS.zip) =>
    Yup.string()
      .trim()
      .matches(/^[\d]{5}$/, {
        excludeEmptyString: true,
        message: errorString,
      }),
  //https://www.w3resource.com/javascript/form/email-validation.php
  email: (errorString = FORM_VALIDATION_ERRORS.email, requiredErrorString = FORM_VALIDATION_ERRORS.email) =>
    Yup.string()
      .trim()
      // eslint-disable-next-line prettier/prettier
      .matches(
        /^((\w+([\.\-+]\w+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        errorString
      )
      .required(requiredErrorString),
  password: () => Yup.string().min(6, FORM_VALIDATION_ERRORS.password).required(FORM_VALIDATION_ERRORS.password),
};

export default capsuleValidation;
